let companyId =
  localStorage.getItem("data") &&
  JSON.parse(localStorage.getItem("data"))?.companyId;
export const masterConfig = () => ({
  vehicleTitle: "Vehicle",
  vehicleNumber: "Vehicle Number",
  siteTitle: "Site",
  currentFuelTitle: companyId === 38 || companyId === 51 ? "Current Load" : "Current Fuel",
  CapacityTitle: companyId === 38 || companyId === 51 ? "Load Capacity" : "Tank Capacity",
  unit: companyId === 38 || companyId === 51 ? "(Kg)" : "(Ltr.)",
  currentLoad: companyId === 38 || companyId === 51 ? true : false,
  transporterTitle:
    companyId === 38 || companyId === 51
      ? "Contractor"
      : companyId === 43
      ? "Vendor"
      : "Transporter",
  lockDeatails: companyId === 43 || companyId === 55 || companyId === 54 || companyId === 56 ? true : false,
});
